import { render, staticRenderFns } from "./zysy.vue?vue&type=template&id=7a20478c&scoped=true"
import script from "./zysy.vue?vue&type=script&lang=js"
export * from "./zysy.vue?vue&type=script&lang=js"
import style0 from "./zysy.vue?vue&type=style&index=0&id=7a20478c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a20478c",
  null
  
)

export default component.exports